import SmoothScroll from 'smooth-scroll'
import Navigation from './lib/navigation'
import stickyContent from './lib/stickyContent'
import Accordion from './lib/accordion'
import Splide from '@splidejs/splide'

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false,
  offset: (anchor, toggle) => {
    if(toggle.href == '#'){
      return 0
    }else{
      const headerHeight = document.querySelector('.header') ?
        document.querySelector('.header').offsetHeight : 0;
      return headerHeight
    }
  }
})

Navigation('header__nav-btn', 'body')
Accordion()
Accordion(300, '.footer__nav-sp .menu-item-has-children > a')
Accordion(300, '.header__nav__ul .menu-item-has-children > a')

stickyContent([
  ['scroll-top', 'footer']
])

// slider -------------------------------------------------

const options = {
  mediaQuery: "min",
  perMove: 1,
  gap: "15px",
  arrows: false,
  pagination: true,
  autoWidth: true,
  autoplay: true,
  interval: 3000,
}
const banners_options = {
  ...options,
  arrows: true,
  focus: "center",
  type: "loop",
  breakpoints: {
    768: {
      gap: "15px",
    },
  },
}
if(document.querySelector('.top-head-banners__slider')) {
  new Splide( '.top-head-banners__slider', banners_options ).mount()
}
